<script>
import Loader from "@/components/_Shared/Loader";

import moment from "@/utils/moment";
import numberMixin from "@/mixins/numberMixin";

import { mapState, mapGetters, mapActions } from "vuex";
import { event } from "vue-analytics";

export default {
  components: {
    Loader
  },
  data() {
    return {
      preloader: false
    };
  },
  mixins: [numberMixin],
  computed: {
    ...mapState("newOrder", [
      "to_be",
      "price",
      "discounted_price",
      "professionals_available",
      "ends_at"
    ]),
    ...mapGetters("newOrder", ["duration"])
  },

  methods: {
    ...mapActions("newOrder", ["searchProfessionalsAvailable"]),
    ...mapActions("professionalsSuggestion", [
      "setStartsAt",
      "setEndsAt",
      "setDistrict",
      "searchAvailableProfessionalsByDuration",
      "setDuration"
    ]),

    setProfessionalsSuggestionData() {
      let day = moment(this.$store.state.newOrder.day).format("Y-MM-DD ");
      let starts_at = day + this.$store.state.newOrder.starts_at;
      let ends_at = day + this.$store.state.newOrder.ends_at;
      let district = this.$store.state.newOrder.address.district;
      this.setStartsAt(starts_at);
      this.setEndsAt(ends_at);
      this.setDistrict(district);
      this.setDuration(this.duration);
    },

    async search() {
      this.preloader = true;

      try {
        await this.searchProfessionalsAvailable();
        if (
          this.professionals_available &&
          this.professionals_available.length == 0
        ) {
          this.setProfessionalsSuggestionData();
          this.preloader = false;
          await this.searchAvailableProfessionalsByDuration();
          this.$emit("scrollTo", "#professionals-suggestions");
        } else {
          this.$emit("scrollTo", "#professionals");
        }
      } catch (e) {
        this.$toasted.error(
          "Ocorreu um erro ao buscar profissionais disponíveis!"
        );
      }

      this.preloader = false;
    },

    selfSearch() {
      if (this.to_be === "schedule") this.search();
    }
  },

  mounted() {
    this.selfSearch();
  },

  watch: {
    ends_at() {
      if (this.ends_at) this.selfSearch();
    }
  }
};
</script>

<template>
  <div class="section">
    <div class="preview-schedule">
      {{duration}} HORAS DE LIMPEZA
      <span class="with-discount" v-if="discounted_price">
        <small class="discount">DE {{price | intToCurrency}}</small>
        POR {{discounted_price | intToCurrency}}
      </span>
      <span v-else>POR {{price | intToCurrency}}</span>
      <p>Produtos de limpeza, transporte e alimentação do profissional inclusos.</p>
    </div>
    <loader v-if="preloader" />
  </div>
</template>

<style scoped>
.with-discount {
  display: inline-flex;
  align-items: flex-start;
  flex-direction: column;
  transform: translateY(-18px);
}

.with-discount .discount {
  text-decoration: line-through;
  font-size: 11px;
  line-height: 5px;
  color: #333 !important;
}

.preview-schedule {
  font-size: 20px;
  font-weight: 600;
  text-align: center;
}

.preview-schedule span,
.preview-schedule p {
  margin-top: 5px;
  color: var(--pink);
}

.preview-schedule p {
  font-size: 12px;
  font-weight: 400;
}

@media (max-width: 468px) {
  .with-discount {
    align-items: center;
    transform: translateY(-5px);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/PurchaseFlow/Steps/ConfirmPeriodAndPrice.vue